import { Outlet } from 'react-router-dom';

export const Webpages = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};
